import { KYMW2300Model } from '../kymw2300.model';
import { GetPageInfoModel } from '../vo/get-page-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 印刷会社用データ出力画面　ページ情報を取得するサービス
 *
 * @export GetPageInfoService
 * @class GetPageInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPageInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW2300Model}
   * @memberof GetPageInfoService
   */
  private model: KYMW2300Model;
  private vo: GetPageInfoModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPageInfoService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        ProgressNum: this.vo.progressNum
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {GetPageInfoModel} vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPageInfoService
   */
  execute(model: KYMW2300Model, vo: GetPageInfoModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW23GetPageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPageInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
